/* eslint-disable no-labels */
import { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Title from "../Components/Layout/Title";
import Intro from "../Components/Layout/Intro";

//Components
import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CssBaseline from "@material-ui/core/CssBaseline";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Navbar from "../Components/Layout/Navbar";
import Post from "../Components/Post/Post";
import PostSkeleton from "../util/PostSkeleton";

//Material Ui Stuff
import Grid from "@material-ui/core/Grid";

//Redux stuff
import { getPosts } from "../redux/actions/dataActions";

function ElevationScroll(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const Home = (props) => {
  const { getPosts } = props;
  const { posts, loading } = props.data;

  useEffect(() => {
    getPosts();
  }, [getPosts]);

  let recentPostsMarkup = !loading ? (
    posts.map((post) => <Post key={post.postId} post={post} />)
  ) : (
    <PostSkeleton />
  );

  return (
    <React.Fragment>
      <Navbar />
      <Container
        style={{ marginTop: "5rem", paddingBottom: "0.5rem" }}
        maxWidth="sm"
      >
        <Title label="Feed" />
        <Intro />
        {recentPostsMarkup}
      </Container>
    </React.Fragment>
  );
};

Home.propTypes = {
  getPosts: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps, { getPosts })(Home);
